// extracted by mini-css-extract-plugin
module.exports = {"shadowBlock":"expand-button-plans_shadowBlock__3-CYO","open":"expand-button-plans_open__1OYLn","expand":"expand-button-plans_expand__1doVF"};